import React from 'react';

import './styles.scss';
import WarningCircleIcon from '../../assets/error.svg';

const InfoMessage = ({ text }) => {
  return (
    <div className="info-wrapper">
      <img className="info-message-icon" src={WarningCircleIcon} alt="warning-icon" />
      <p className="info-text">{text}</p>
    </div>
  );
};

export default InfoMessage;
